import React, { useState } from 'react';

import bg from '../assets/images/hero/bg.jpg'
import coin1 from '../assets/images/bitcoin.png'
import coin2 from '../assets/images/ethereum.png'
import coin3 from '../assets/images/coin/Bitcoin-BTC.png'
import coin4 from '../assets/images/coin/Ethereum-ETH.png'
import coin5 from '../assets/images/coin/Avalanche-AVAX.png'
import coin6 from '../assets/images/coin/BNB-BNB.png'
import coin7 from '../assets/images/coin/Cardano-ADA.png'
import coin8 from '../assets/images/coin/Dai-DAI.png'
import coin9 from '../assets/images/coin/Polkadot-DOT.png'
import coin10 from '../assets/images/coin/Shiba-Inu-SHIB.png'
import { Link } from 'react-router-dom'

import TinySlider from "tiny-slider-react";
import '../../node_modules/tiny-slider/dist/tiny-slider.css'

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/scss/modal-video.scss'
import { FiVideo } from 'react-icons/fi';


export default function HomeBanner() {
    let [isOpen, setOpen] = useState(false);

    const settings = {
        container: '.tiny-three-item-icon',
        controls: true,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        controlsText: ['<i class="mdi mdi-chevron-left "></i>', '<i class="mdi mdi-chevron-right"></i>'],
        nav: false,
        speed: 400,
        gutter: 0,
        responsive: {
            992: {
                items: 3
            },

            767: {
                items: 2
            },

            320: {
                items: 1
            },
        },
      };

const data = [
        {
            image:coin3,
            name:'Bitcoin (BTC)',
            amount:'$45762',
            value:'5.25%',
            status:'profit'
        },
        {
            image:coin4,
            name:'Ethereum (ETH)',
            amount:'$45762',
            value:'5.25%',
            status:'loss'
        },
        {
            image:coin5,
            name:'Avalanche (AVAX)',
            amount:'$45762',
            value:'5.25%',
            status:'profit'
        },
        {
            image:coin6,
            name:'BNB (BNB)',
            amount:'$45762',
            value:'5.25%',
            status:'profit'
        },
        {
            image:coin7,
            name:'Cardano (ADA)',
            amount:'$45762',
            value:'5.25%',
            status:'loss'
        },
        {
            image:coin8,
            name:'Dai (DAI)',
            amount:'$45762',
            value:'5.25%',
            status:'loss'
        },
        {
            image:coin9,
            name:'Polkadot (DOT)',
            amount:'$45762',
            value:'5.25%',
            status:'profit'
        },
        {
            image:coin10,
            name:'Shiba Inu (SHIB)',
            amount:'$45762',
            value:'5.25%',
            status:'loss'
        },
    ]
  return (
        <section className="bg-half-260 position-relative overflow-hidden pb-5" style={{backgroundImage:`url(${bg})`, backgroundPosition:'top', backgroundRepeat:'no-repeat'}} id='home'>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container position-relative">
                <div className="row justify-content-center">
                    <div className="col-lg-12 text-center">
                        <div className="title-heading position-relative z-1 margin-top-100">
                            <h1 className="display-3 text-white title-dark lh-base mb-4">New Digital App for <br/> Cryptocurrency</h1>
                            <p className="para-desc mx-auto text-white-50">Our platform reaches people all over the world, hereby we are trusted as the best platform for crypto trading.</p>
                            <div className="mt-4 pt-2">
                                <Link to="/services" className="btn btn-lg btn-pills btn-primary m-1">Join Now</Link>
                                <Link to="#!" onClick={() => setOpen(true)} className="btn btn-lg btn-icon btn-pills btn-soft-primary m-1 lightbox"><FiVideo className="icons"/></Link><span className="fw-bold small text-uppercase text-white title-dark align-middle ms-2">Watch Now</span>
                            </div>
                        </div>
                        <ModalVideo
                            channel="youtube"
                            youtube={{ mute: 0, autoplay: 0 }}
                            isOpen={isOpen}
                            videoId="yba7hPeTSjk"
                            onClose={() => setOpen(false)} 
                        />
                    </div>
                </div>

                <div className="position-absolute top-0 end-0 translate-middle-y">
                    <img src={coin1} className="avatar avatar-large mover" alt=""/>
                </div>

                <div className="position-absolute bottom-0 start-0">
                    <img src={coin2} className="avatar avatar-large mover" alt=""/>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row">
                    <div className="col-12">
                        <div className="tiny-three-item-icon">
                            <TinySlider settings={settings}>
                                {data.map((item,index)=>{
                                    return(
                                        <div className="tiny-slide" key={index}>
                                            <div className="position-relative overflow-hidden rounded shadow bg-white p-4 m-2">
                                                <div className="position-relative d-flex align-items-center justify-content-between z-1">
                                                    <div className="d-flex align-items-center">
                                                        <img src={item.image} className="rounded-pill shadow bg-white avatar avatar-md-sm" alt=""/>
                                                        
                                                        <div className="ms-3">
                                                            <h6 className="mb-1"><Link to="#" className="text-dark link-title">{item.name}</Link></h6>
                                                            <h6 className={`small mb-0 ${item.status === 'profit' ? 'text-success' : 'text-danger'}`}>{item.amount}</h6>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="ms-2">
                                                        <span className={`badge bg-success rounded-pill ${item.status === 'profit' ? 'bg-success' : 'bg-danger'}`}>{item.value}</span>
                                                    </div>
                                                </div>
                                                
                                                <div className="position-absolute top-50 start-100 translate-middle">
                                                    <img src={item.image} className="avatar avatar-md-md opacity-10 me-5" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </TinySlider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  )
}
